export const INGRID_API_URL = process.env.INGRID_API_URL
export const INGRID_API_KEY = process.env.INGRID_API_KEY

export const INGRID_AUTH_HEADERS = {
  Authorization: `Bearer ${INGRID_API_KEY}`
}
